import React from "react";
import { cn } from "./helpers";

const Badge: React.FC<{ text?: string; allowShrinkage?: boolean }> = ({
  text,
  allowShrinkage,
}) => {
  return (
    <span
      className={cn(
        "block rounded-xl border border-current px-2 pt-1 pb-[0.2rem] text-[0.625rem] uppercase font-medium text-current opacity-75 shrink-0",
        { "truncate shrink-1": allowShrinkage }
      )}
    >
      {text}
    </span>
  );
};

export default Badge;
